import { SEVERITY_LABEL, type FindingStatus, type RiskGrade, type Severity } from '@1qa/shared';
import type { Tone } from '@/components/ui';

export { SEVERITY_LABEL };

/** Badge tone per severity, matching the design system (brand = critical, danger = high, …). */
export const SEVERITY_TONE: Record<Severity, Tone> = {
  CRITICAL: 'brand',
  HIGH: 'danger',
  MEDIUM: 'warning',
  LOW: 'info',
  INFO: 'muted',
};

export const STATUS_LABEL: Record<FindingStatus, string> = {
  EXPLOITED: 'Exploited',
  CONFIRMED: 'Confirmed',
  POTENTIAL: 'Needs review',
  INFO: 'Info',
};

/** Colour of the A–F grade dial in the exec summary (green A → red F). */
export const GRADE_CLASS: Record<RiskGrade, string> = {
  A: 'text-success',
  B: 'text-success',
  C: 'text-warning',
  D: 'text-warning',
  F: 'text-danger-text',
};

export const confidenceWord = (c: number): 'Low' | 'Medium' | 'High' => (c >= 0.8 ? 'High' : c >= 0.5 ? 'Medium' : 'Low');
